import { writable } from 'svelte/store';
import type { Writable } from 'svelte/store';

// Used only by TourFormMobile and TourGirVisibleDates as they are independent
// but VisibleDates triggers the modal from TourFormMobile to be opened
export const isModalOpen = writable(false);
export const modalExtraData: Writable<{
    selectedDate: string | null;
    price: number | null;
    remainingStock: number | null;
    statusName: string;
}> = writable({
    selectedDate: null,
    price: null,
    remainingStock: null,
    statusName: '',
});
